/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import ReportPageComponent from './reportPage.Component';
import { ApiUrls } from '../../../services/api';
import Api from '../../../services/api/serviceCall';
import { Constants } from '../../../config/appConstants';
import { MessageBox } from '../../sharedComponent/messageBox';
import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/login.Action';
import { emailValidation } from '../../../services/utility/index';
/* Project Import will be here */

class ReportPage extends Component {
    constructor(props) {
        const minHourLimit = 3;
        const maxHourLimit = 11;
        const daysList = [];
        const hourList = [];
        const minuteList = [{ key: 0, text: '00', value: 0 }];

        for (let i = 1; i <= 59; i++) {
            if (i < 10) {
                daysList.push({ key: i, text: '0' + i, value: i });
                minuteList.push({ key: i, text: '0' + i, value: i });
                if (i >= minHourLimit) {
                    hourList.push({ key: i, text: '0' + i, value: i });
                }
            } else {
                if (i <= 31) {
                    daysList.push({ key: i, text: i, value: i });
                }
                if (i <= maxHourLimit) {
                    hourList.push({ key: i, text: i, value: i });
                }
                minuteList.push({ key: i, text: i, value: i });
            }
        }

        super(props);
        this.state = {
            selectedData: this.defaultSelectedState(),
            defaultStateSelectedData: this.defaultSelectedState(),
            selectedTypeDayOrDate: Constants.DAY,
            calanderEndDate: new Date(),
            isDeleteConfirm: false,
            invalidDataFields: [],
            minHourLimit: minHourLimit,
            maxHourLimit: maxHourLimit,
            pagination: {
                totalRecordCount: 0,
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            sendListWithoutReport: ["2", "5", "15"],
            searchArray: [],
            sendReportToId: [],
            selectedProjectIds: [],
            selectedDivisionIds: [],
            selectedTaskcodeIds: [],
            reportType: this.getReportTypes(),
            weekdays: [
                { key: '0', text: 'Sunday', value: '0' },
                { key: '1', text: 'Monday', value: '1' },
                { key: '2', text: 'Tuesday', value: '2' },
                { key: '3', text: 'Wednesday', value: '3' },
                { key: '4', text: 'Thursday', value: '4' },
                { key: '5', text: 'Friday', value: '5' },
                { key: '6', text: 'Saturday', value: '6' },
            ],
            runPeriodOptions: [
                { key: 'Daily', text: 'Daily', value: 'daily' },
                { key: 'Weekly', text: 'Weekly', value: 'weekly' },
                { key: 'Monthly', text: 'Monthly', value: 'monthly' }
            ],
            dates: daysList,
            hours: hourList,
            minutes: minuteList,
            employeeEmails: [],
            projectList: [],
            allProjectIds: [],
            projectDivList: [],
            taskcodeList: [],
            taskcodeDBList: [],
            scheduleList: [],
            isOpenModel: false,
            userEmails: [],
            allUserEmails: [],
            reportDelegateIds: [],
            disabledProjectsList: [],
            disabledTaskCodesList: [],
            disabledDivisionsList: [],
            taskInvolvedReports: this.groupedReportTypes().taskInvolvedReports,
            reportsAccessForProjectManager: this.getReportTypes().filter(report => this.groupedReportTypes().projectManagerReports.includes(report.value)),
            readOnlyReports: this.getReportTypes().filter(report => ![...this.groupedReportTypes().attestationReports, ...this.groupedReportTypes().tmVoucherMetricsReport].includes(report.value)),
            contributorsReports: this.getReportTypes().filter(report => !this.groupedReportTypes().tmVoucherMetricsReport.includes(report.value)),
            isCheckedArchive: false,
            lastArchiveDate: null,
            minimumDate: null,
            isDatePickerEnabled: false
        };
    }

    async componentDidMount() {
        this.getProjectList().then(() => {
            this.getReportScheduleList(true);
        });
        this.getProjectDivisionList();
        this.getUserDetailsList();
        this.getEmployeeDetailsList();
    }

    getReportTypes() {
        return [
            { key: 'Unit Notes Report with Date Range and Install Rates', text: 'Unit Notes Report with Date Range and Install Rates', value: '1' },
            { key: 'Daily Job Report by Foreman (One Project)', text: 'Daily Job Report by Foreman (One Project)', value: '2' },
            { key: 'Daily Job Report to GC with Issues', text: 'Daily Job Report to GC with Issues', value: '3' },
            { key: 'Double Time Report per Week', text: 'Double Time Report per Week', value: '4' },
            { key: 'Daily Job Report by Foreman', text: 'Daily Job Report by Foreman', value: '5' },
            { key: 'Time Voucher Report', text: 'Time Voucher Report', value: '6' },
            { key: 'Material Handler Report', text: 'Material Handler Report', value: '7' },
            { key: 'Daily Job Report to GC with Issues - Group by Foreman', text: 'Daily Job Report to GC with Issues - Group by Foreman', value: '8' },
            { key: 'Work Notes Report with Task Codes', text: 'Work Notes Report with Task Codes', value: '9' },
            // { key: 'Unit Notes with Actual and Expectations Report', text: 'Unit Notes with Actual and Expectations Report', value: '10' },
            { key: 'Timecard data by project', text: 'Timecard data by project', value: '11' },
            { Key: 'Issue Notes Report', text: 'Issue Notes Report', value: '12' },
            { key: 'Field Roster by Project', text: 'Field Roster by Project', value: '13' },
            { key: 'Field Roster by Division', text: 'Field Roster by Division', value: '14' },
            { key: 'Daily GC Report by Foreman', text: 'Daily GC Report by Foreman', value: '15' },
            { key: 'Daily Job Report to GC with T&M Tags', text: 'Daily Job Report to GC with T&M Tags', value: '16' },
            { key: 'T&M Voucher', text: 'T&M Voucher', value: '17' },
            { key: 'TM Roll Up', text: 'TM Roll Up', value: '18' },
            { key: "Attested 'No' Report", text: "Attested 'No' Report", value: '19' },
            { key: 'Supervisor Override Report', text: 'Supervisor Override Report', value: '20' },
            { key: 'Unit Notes Report with Date Range and Install Rates - Hours/Units', text: 'Unit Notes Report with Date Range and Install Rates - Hours/Units', value: '21' },
            { key: 'TM Voucher Metrics', text: 'TM Voucher Metrics', value: '22' }
        ];
    }

    groupedReportTypes() {
        return {
            tmVoucherReports: ["17", "18"],
            tmVoucherMetricsReport: ["22"],
            attestationReports: ["19", "20"],
            projectManagerReports: ["13", "14", "17", "18", "21"],
            unitNoteWithInstallRateReport: ["21"],
            taskInvolvedReports: ["6", "17", "18"],
            fieldRosterByDivisionReport: ["14"],
        }
    }

    defaultSelectedState() {
        return {
            scheduleName: "",
            description: "",
            run: "",
            reportType: "",
            runReportAt: "",
            subject: "",
            message: "",
            weekday: "",
            scheduleHour: "",
            scheduleMinute: "",
            startDate: 0,
            endDate: 0,
            dateInMonth: 0,
            projects: [],
            divisions: [],
            taskCodes: [],
            sendReportTo: [],
            reportDelegate: [],
            selectedToDate: null,
            selectedFromDate: null,
        };
    }

    handleAddition = (e, { value }) => {
        const isValidEmail = emailValidation(value);
        const savedEmail = this.state?.employeeEmails?.find(e => e.text?.toLowerCase() === value?.toLowerCase());
        const isAlreadySelected = savedEmail && this.state?.sendReportToId?.find(s => s === savedEmail.value);

        if (isValidEmail && !isAlreadySelected) {
            const added = {
                value: value.toLowerCase(),
                key: value.toLowerCase(),
                icon: "mail",
                text: value.toLowerCase()
            };
            this.setState(prevState => ({
                employeeEmails: [added, ...prevState.employeeEmails]
            }));
        } else {
            const message = isAlreadySelected ? Constants.ENTER_EMAIL_ALREADY_SELECTED : Constants.PLEASE_ENTER_VALID_EMAIL;
            const newSendReportTo = [];

            if (isValidEmail && isAlreadySelected) {
                const emailMap = new Set();
                const alreadySavedEmailIds = this.state?.sendReportToId;

                alreadySavedEmailIds.forEach((email) => {
                    const currentEmail = this.state?.employeeEmails?.find(e => e.key?.toLowerCase() === email?.toLowerCase());
                    const key = currentEmail ? currentEmail.text.toLowerCase() : email.toLowerCase();
                    if (!emailMap.has(key)) {
                        newSendReportTo.push(email);
                        emailMap.add(key);
                    }
                });
            } else {
                newSendReportTo.push(...this.state?.sendReportToId.filter(a => a !== value));
            }

            this.setState({ sendReportToId: newSendReportTo });
            return MessageBox(message, Constants.ERROR);
        }
    };

    getEmployeeDetailsList() {
        const url = `${ApiUrls.Routes.SCHDULER_C}${ApiUrls.Routes.GT_EMLFREPTSCHDULS_M}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData && responseData.success) {
                const options = [];
                responseData.data.forEach(d => {
                    const id = d.id > 0 ? d.id : d.empID > 0 ? d.empID : d.userId;
                    options.push({
                        value: `${d.contactType}-${id}`,
                        key: `${d.contactType}-${id}`,
                        icon: d.contactType === "Employee" ? "user outline" : d.contactType === "User" ? "shield alternate" : "mail",
                        text: d.employeeEmailAddress.toLowerCase()
                    });
                });
                this.setState({ employeeEmails: options });
            } else {
                this.setState({ employeeEmails: [] });
            }
        });
    }

    getUserDetailsList() {
        const url = `${ApiUrls.Routes.SCHDULER_C}${ApiUrls.Routes.GT_USRREPTSCHDULS_M}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData && responseData.success) {
                const options = [];
                responseData.data.forEach(d => {
                    const id = d.empID > 0 ? d.empID : 0;
                    if (id !== this.props.user.userId) {
                        options.push({
                            value: id,
                            key: id,
                            icon: "shield alternate",
                            text: d.employeeEmailAddress.toLowerCase(),
                            securityGroupName: d.securityGroupName
                        });
                    }
                });
                this.setState({
                    userEmails: options,
                    allUserEmails: JSON.parse(JSON.stringify(options))
                });
            } else {
                this.setState({ userEmails: [] });
            }
        });
    }

    getProjectList() {
        return new Promise(async (resolve) => {
            const requestData = {
                SearchText: [{
                    FieldName: Constants.USER_ID,
                    value: this.props.user.userId.toString()
                }],
                Status: 'active'
            };

            const projectList = [];
            try {
                //TODO : need to get app project without skip take
                const url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_PJT_LT_M}`;
                const responseData = await Api.Post(url, requestData, this);
                if (responseData && responseData.success) {
                    responseData.data.forEach(d => {
                        projectList.push({
                            value: d.id, key: d.id, text: `${d.projectNumber} - ${d.projectName}`
                        });
                    });
                }
            } catch (error) { }
            this.setState({ projectList });
            resolve(true);
        });
    }

    getProjectDivisionList() {
        const url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_PJTDIV_LT_M}?userId=${this.props.user.userId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData && responseData.success) {
                const divOptions = [];
                responseData.data.forEach(d => {
                    if (d.divisionName != null) {
                        divOptions.push({
                            value: d.divisionName, key: d.divisionName, text: `${d.divisionName}`
                        });
                    }
                });
                this.setState({ projectDivList: divOptions });
            } else {
                this.setState({ projectDivList: [] });
            }
        });
    }

    saveReportScheduleDetails(isRunNow = false) {
        let { selectedData } = this.state;
        if (this.isValidateFormData(isRunNow)) {
            if (selectedData.projects.length > 1) {
                const isInvalidProject = selectedData.projects.find(a => a.isAllProject);
                if (isInvalidProject !== undefined) {
                    MessageBox(Constants.ALL_PROJECT_INVALID_OPTION, Constants.ERROR);
                    return;
                }
            }

            if (this.state.selectedData.endDate > this.state.selectedData.startDate && this.state.selectedData.run !== Constants.RUN_DAILY) {
                return MessageBox(Constants.PLEASE_ENTER_VALID_END_DATE, Constants.ERROR);
            }

            const sendReportTo = this.state.sendReportToId.map(c => {
                const val = c.split('-');
                return {
                    id: val[0] === "Contact" ? parseInt(val[1]) : 0,
                    empID: val[0] === "Employee" ? parseInt(val[1]) : 0,
                    userId: val[0] === "User" ? parseInt(val[1]) : 0,
                    contactType: val.length === 1 ? "Contact" : val[0],
                    employeeEmailAddress: val.length === 1 ? val[0] : null
                }
            });

            const reportDelegateId = this.state.reportDelegateIds.map(a => ({
                userId: a
            }));

            const selectedTaskCodes = [];
            this.state.selectedTaskcodeIds.map(id => {
                const selectedObject = this.state.taskcodeDBList.find(t => t.id === parseInt(id));
                if (selectedObject !== undefined) {
                    selectedTaskCodes.push({
                        projectID: selectedObject.projectId,
                        projectTaskID: selectedObject.id
                    });
                }
            });

            const validSendReportTo = [];
            for (let i = 0; i < sendReportTo.length; i++) {
                const data = sendReportTo[i];
                const isValid = data.employeeEmailAddress ? emailValidation(data.employeeEmailAddress) : true;
                if (isValid) {
                    validSendReportTo.push(data);
                }
            }

            const vaidReportDelegates = [];
            for (let i = 0; i < reportDelegateId.length; i++) {
                const data = reportDelegateId[i];
                const isValid = data.employeeEmailAddress ? emailValidation(data.employeeEmailAddress) : true;
                if (isValid) {
                    vaidReportDelegates.push(data);
                }
            }

            this.state.selectedData.divisions = this.state.selectedData.divisions && this.state.selectedData.divisions.filter(data => !(data.id == 0 && data.isDeleted === true));

            if ((validSendReportTo && validSendReportTo.length > 0) || this.state.sendListWithoutReport.includes(this.state.selectedData.reportType)) {
                this.state.selectedData.sendReportTo = validSendReportTo;
                this.state.selectedData.scheduleName = this.state.selectedData.scheduleName.trim()
                this.state.selectedData.reportDelegate = vaidReportDelegates;
                let requestData = Object.assign({ createdById: this.props.user.userId }, this.state.selectedData);
                requestData.ProjectTasks = selectedTaskCodes;
                if (isRunNow) {
                    requestData.runReportAt = Constants.NOW
                    requestData.scheduleHour = 0;
                    requestData.scheduleMinute = 0;
                    requestData.createdById = this.props.user.userId;
                }

                const url = `${ApiUrls.Routes.SCHDULER_C}${ApiUrls.Routes.GT_SAVREPSCH_M}?isCheckedArchive=${this.state.isCheckedArchive}`;
                Api.Post(url, requestData, this).then(async (responseData) => {
                    if (responseData.success) {
                        this.onCloseModel(false);
                        this.getProjectList().then(() => {
                            this.getReportScheduleList();
                        });
                        this.getUserDetailsList();
                        this.getEmployeeDetailsList();
                    }
                    MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                });
            } else {
                return MessageBox(Constants.ENTER_VALID_EMAIL, Constants.ERROR);
            }
        }
    }

    validateEmptyInputFields(fieldName, fieldValue, required, fieldId = "") {
        if (required) {
            let { invalidDataFields } = this.state;
            if (!fieldValue && fieldValue !== 0) {
                if (invalidDataFields.find(a => a === fieldName) === undefined) {
                    invalidDataFields.push(fieldName);
                    this.setState({ invalidDataFields });
                }
            } else {
                if (invalidDataFields.some(a => a === fieldName)) {
                    for (let i = invalidDataFields.length - 1; i >= 0; i--) {
                        if (invalidDataFields[i] === fieldName) {
                            invalidDataFields.splice(i, 1);
                            break;
                        }
                    }
                }
                this.setState({ invalidDataFields });
            }
        }
        // this.setState({
        //     [fieldName]: fieldValue
        // }, () => {
        //     if (fieldId) {
        //         focusInputElementInReactTable(fieldId);
        //     }
        // });
    }

    validateDateFields(fieldName, fieldValue) {
        let { invalidDataFields } = this.state;
        if (fieldValue && fieldValue > 28) {
            if (invalidDataFields.find(a => a === fieldName) === undefined) {
                invalidDataFields.push(fieldName);
                this.setState({ invalidDataFields });
            }
        } else {
            if (invalidDataFields.some(a => a === fieldName)) {
                for (let i = invalidDataFields.length - 1; i >= 0; i--) {
                    if (invalidDataFields[i] === fieldName) {
                        invalidDataFields.splice(i, 1);
                        break;
                    }
                }
            }
            this.setState({ invalidDataFields });
        }
    }

    getReportScheduleList(initialCall = false) {
        let { searchArray, pagination, minimumDate, lastArchiveDate } = this.state;
        const requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take,
            Status: this.state.selectedStatus
        };

        const url = `${ApiUrls.Routes.SCHDULER_C}${ApiUrls.Routes.GT_REPTSCHDULS_M}?userId=${this.props.user.userId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalRecordCount = responseData.totalCount;
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    if (initialCall && responseData.data.lastArchiveDate) {
                        let archiveDate = new Date(responseData.data.lastArchiveDate);
                        archiveDate = new Date(archiveDate.setDate(archiveDate.getDate() + 1));
                        minimumDate = archiveDate;
                        lastArchiveDate = archiveDate;
                    }
                    this.setState({
                        scheduleList: responseData.data.reportSchedules,
                        pagination,
                        lastArchiveDate,
                        minimumDate,
                        isDatePickerEnabled: true
                    });
                } else {
                    this.setState({ scheduleList: [], isDatePickerEnabled: true });
                }
            }
        });
    }

    getTaskList(selectedProjectIds, isTMCode = false) {
        const url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_PRJT_TSK_CDS_M}?isTMCode=${isTMCode}&&isCheckedArchive=${this.state.isCheckedArchive}`;
        Api.Post(url, selectedProjectIds, this).then((responseData) => {
            if (responseData && responseData.success) {
                const taskCodeData = responseData?.data ?? [];
                const taskCodeList = [];
                const accessibleSelectedTaskCodes = taskCodeData.filter(d => !this.state.disabledProjectsList.some(v => d.projectId == v.id));

                accessibleSelectedTaskCodes.map((d, i) => {
                    taskCodeList.push({
                        value: d.id,
                        key: `${d.id}-${i}`,
                        text: `${d.taskNumber}-${d.taskName}`
                    });
                });

                this.setState({
                    taskcodeList: taskCodeList,
                    taskcodeDBList: responseData.data
                });
            } else {
                this.setState({ taskcodeList: [] });
            }
        });
    }

    isValidateFormData(isRunNow = false) {
        const { selectedData, selectedTypeDayOrDate, selectedDivisionIds } = this.state;
        const { taskInvolvedReports, fieldRosterByDivisionReport } = this.groupedReportTypes();
        const isTaskCodeRequired = taskInvolvedReports.includes(selectedData.reportType);
        const isDivisionRequired = fieldRosterByDivisionReport.includes(selectedData.reportType);
        return (selectedData && selectedData.scheduleName &&
            selectedData.scheduleName.trim() &&
            ((selectedData.selectedFromDate && selectedData.selectedToDate && selectedData.selectedFromDate <= selectedData.selectedToDate) || selectedTypeDayOrDate === Constants.DAY) &&
            (selectedData.selectedToDate || selectedTypeDayOrDate === Constants.DAY) &&
            selectedData.description &&
            (selectedData.run || selectedTypeDayOrDate === Constants.DATE) &&
            selectedData.reportType &&
            ((selectedData.startDate > 0 && selectedData.endDate > 0 && selectedData.run !== "daily") || selectedData.run === "daily" || isRunNow) &&
            ((isDivisionRequired) ? (selectedDivisionIds && selectedDivisionIds.length > 0) : (selectedData.projects && selectedData.projects.length > 0)) &&
            (!isTaskCodeRequired || (selectedData.taskCodes && selectedData.taskCodes.length > 0)) &&
            ((this.state.sendReportToId && this.state.sendReportToId.length > 0) || (this.state.sendListWithoutReport.includes(selectedData.reportType))) &&
            selectedData.subject &&
            selectedData.message &&
            ((selectedData.run === "weekly" && selectedData.weekday || selectedData.run !== "weekly") &&
                (selectedData.run === "monthly" && selectedData.dateInMonth > 0 || selectedData.run !== "monthly") || isRunNow) &&
            ((selectedData.scheduleHour && selectedData.scheduleMinute !== "" && selectedData.scheduleMinute >= 0) || isRunNow));
    }

    handleFormChange = (e, { name, value }) => {
        let { userEmails, allUserEmails, reportDelegateIds, projectList, isCheckedArchive, lastArchiveDate, minimumDate, calanderEndDate } = this.state;

        const roleName = this.props.user.roleName;
        const adminRoles = [Constants.ADMIN_ROLE_NAME, Constants.SYSTEM_ADMIN_ROLE_NAME];
        const isAdminRole = adminRoles.includes(roleName);
        const { attestationReports, projectManagerReports, taskInvolvedReports, tmVoucherMetricsReport, tmVoucherReports, unitNoteWithInstallRateReport, fieldRosterByDivisionReport } = this.groupedReportTypes();
        const isAllProject = projectList[0]?.key === Constants.ALL_PROJECTS; // Only valid for attestation reports project list has AllProject option as first option
        const allProjectOption = {
            value: Constants.ALL_PROJECTS,
            key: Constants.ALL_PROJECTS,
            text: "All Projects"
        };

        if (name && this.state.selectedData) {
            const selectedData = Object.assign({}, this.state.selectedData);  // Creating copy of state variable

            switch (name) {
                case "scheduleName":
                    selectedData.scheduleName = value;
                    break;
                case "description":
                    selectedData.description = value;
                    break;
                case "run": {
                    if (value === Constants.RUN_DAILY) {
                        selectedData.startDate = 0;
                        selectedData.endDate = 0;
                        selectedData.weekday = "";
                        selectedData.dateInMonth = 0;
                    } else if (value === Constants.RUN_WEEKLY) {
                        selectedData.dateInMonth = 0;
                    } else if (value === Constants.RUN_MONTHLY) {
                        selectedData.weekday = "";
                    }
                    selectedData.run = value;
                    e.target.name = "run";
                }
                    break;
                case "reportType": {
                    const reportType = value;
                    const isProjectManagerReport = projectManagerReports.includes(reportType);
                    const isUnitNoteWithInstallRateReport = unitNoteWithInstallRateReport.includes(reportType);
                    const isAttestationReport = attestationReports.includes(reportType);
                    const isTmVoucherMetricsReport = tmVoucherMetricsReport.includes(reportType);

                    selectedData.reportType = reportType;
                    e.target.name = "reportType";

                    if (this.state.sendListWithoutReport.includes(reportType)) {
                        this.state.sendReportToId = [];
                    }

                    if (!fieldRosterByDivisionReport.includes(reportType)) {
                        this.state.selectedDivisionIds = [];
                        selectedData.divisions = [];
                    } else {
                        this.state.selectedProjectIds = [];
                        selectedData.projects = [];
                    }

                    if (!taskInvolvedReports.includes(reportType)) {
                        this.state.selectedTaskcodeIds = [];
                        selectedData.taskCodes = [];
                    }

                    if (this.state.selectedProjectIds.length > 0 && taskInvolvedReports.includes(reportType)) {
                        const selectedProjectIds = this.state.selectedProjectIds.map(projectId => ({ id: projectId }));
                        this.getTaskList(selectedProjectIds, tmVoucherReports.includes(reportType));
                    }

                    // Setting all project option if not already selected for Attestation reports for admin role
                    if (isAdminRole && isAttestationReport && !isAllProject) {
                        this.setState({
                            projectList: [allProjectOption, ...this.state.projectList]
                        });
                    } else if (!isAttestationReport && isAllProject) { // Remove AllProject option in the project list if it is not Attestation reports and AllProject option is selectec
                        selectedData.projects = selectedData.projects.filter(a => !a.isAllProject);
                        this.setState({
                            projectList: this.state.projectList.filter(a => a.key !== Constants.ALL_PROJECTS),
                            selectedProjectIds: this.state.selectedProjectIds.filter(a => a !== Constants.ALL_PROJECTS)
                        })
                    }

                    const isSelectedAllProject = selectedData?.projects[0]?.isAllProject ?? false;
                    const reportDelegates = this.getReportDelegates(isAttestationReport, isSelectedAllProject, isProjectManagerReport, isUnitNoteWithInstallRateReport, isTmVoucherMetricsReport, userEmails, reportDelegateIds);
                    reportDelegateIds = reportDelegates.reportDelegateIds;
                    userEmails = reportDelegates.userEmails;
                }
                    break;
                case "selectedTypeDayOrDate": {
                    this.state.selectedTypeDayOrDate = value;
                    minimumDate = lastArchiveDate;
                    calanderEndDate = new Date();
                    if (this.state.selectedTypeDayOrDate === Constants.DAY) {
                        selectedData.selectedFromDate = null;
                        selectedData.selectedToDate = null;
                        isCheckedArchive = false;
                    } else {
                        selectedData.selectedFromDate = null;
                        selectedData.selectedToDate = null;
                        selectedData.run = "";
                        selectedData.startDate = 0;
                        selectedData.endDate = 0;
                        selectedData.runReportAt = "";
                        selectedData.weekday = "";
                        selectedData.dateInMonth = 0;
                        selectedData.scheduleHour = "";
                        selectedData.scheduleMinute = "";
                    }
                    e.target.name = "selectedTypeDayOrDate";
                }
                    break;
                case "weekday":
                    selectedData.weekday = value;
                    e.target.name = "weekday";
                    break;
                case "dateInMonth":
                    selectedData.dateInMonth = value;
                    e.target.name = "dateInMonth";
                    break;
                case "scheduleHour": {
                    // if (value == Constants.NOW) {
                    //     selectedData.runReportAt = value;
                    //     selectedData.scheduleHour = value;
                    // }
                    // else {
                    selectedData.runReportAt = "";
                    selectedData.scheduleHour = value;
                    //}
                    if (selectedData.scheduleHour >= this.state.maxHourLimit) {
                        selectedData.scheduleMinute = 0;
                    }
                    e.target.name = "scheduleHour";
                }
                    break;
                case "scheduleMinute":
                    selectedData.scheduleMinute = value;
                    e.target.name = "scheduleMinute";
                    break;
                case "selectedProject": {
                    const reportType = selectedData.reportType;
                    const isProjectManagerReport = projectManagerReports.includes(reportType);
                    const isUnitNoteWithInstallRateReport = unitNoteWithInstallRateReport.includes(reportType);
                    const isAttestationReport = attestationReports.includes(reportType);
                    const isTmVoucherMetricsReport = tmVoucherMetricsReport.includes(reportType);

                    this.state.selectedProjectIds = value;
                    if (value.length === 0) {
                        userEmails = allUserEmails.filter(a => isProjectManagerReport || isUnitNoteWithInstallRateReport || a.securityGroupName !== Constants.PROJECT_MANAGER);
                    }

                    const selectedProjectIds = this.state.selectedProjectIds.map(t => {
                        if (t === Constants.ALL_PROJECTS) {
                            return { id: 0, isAllProject: true };
                        }
                        return { id: t };
                    });

                    const isSelectedAllProject = this.state.selectedProjectIds.includes(Constants.ALL_PROJECTS);
                    const reportDelegates = this.getReportDelegates(isAttestationReport, isSelectedAllProject, isProjectManagerReport, isUnitNoteWithInstallRateReport, isTmVoucherMetricsReport, userEmails, reportDelegateIds);
                    reportDelegateIds = reportDelegates.reportDelegateIds;
                    userEmails = reportDelegates.userEmails;

                    selectedData.projects = selectedProjectIds;
                    e.target.name = "selectedProject";

                    // Fetch taskcodes for task involved reports like 6, 17, 18
                    if (taskInvolvedReports.includes(selectedData.reportType) && !isSelectedAllProject) {
                        this.getTaskList(selectedProjectIds, tmVoucherReports.includes(selectedData.reportType));
                    }
                }
                    break;
                case "DivisionNumber": {
                    this.state.selectedDivisionIds = value;
                    if (!selectedData.divisions) {
                        const divsionList = this.state.selectedDivisionIds.map(t => {
                            return {
                                id: 0,
                                divisionName: t,
                                reportScheduleId: 0,
                                isDeleted: false
                            };
                        });
                        selectedData.divisions = divsionList;
                    } else {
                        value.map(a => {
                            if (!selectedData.divisions.find(d => d.divisionName === a)) {
                                selectedData.divisions.push({
                                    id: 0,
                                    divisionName: a,
                                    reportScheduleId: selectedData.id,
                                    isDeleted: false
                                });
                            }
                        });
                        selectedData.divisions.map(a => {
                            if (!value.find(d => d === a.divisionName)) {
                                a.isDeleted = true;
                            }
                        });
                    }
                }
                    break;
                case "selectedTaskcode":
                    this.state.selectedTaskcodeIds = value;
                    const selectedTaskcodeIds = this.state.selectedTaskcodeIds.map(t => ({ id: t }));
                    selectedData.taskCodes = selectedTaskcodeIds;
                    e.target.name = "selectedTaskcode";
                    break;
                case "sendReportTo":
                    this.state.sendReportToId = value;
                    e.target.name = "sendReportTo";
                    break;
                case "startDate":
                    if (value === "" || parseInt(value) <= 28) {
                        selectedData.startDate = parseInt(value);
                    }
                    this.validateDateFields("InvalidStartDate", value);
                    break;
                case "endDate":
                    if (value === "" || parseInt(value) <= 28) {
                        selectedData.endDate = parseInt(value);
                    }
                    this.validateDateFields("InvalidEndDate", value);
                    break;
                case "subject":
                    selectedData.subject = value;
                    break;
                case "message":
                    selectedData.message = value;
                    break;
                case "additionalReportDelegates":
                    reportDelegateIds = value;
                    e.target.name = "additionalReportDelegates";
                    break;
                case "handleArchiveCheckboxChange":
                    isCheckedArchive = !value;
                    this.state.selectedTypeDayOrDate = isCheckedArchive ? Constants.DATE : Constants.DAY;
                    this.state.selectedProjectIds = [];
                    this.state.selectedTaskcodeIds = [];
                    this.state.selectedDivisionIds = [];
                    selectedData.projects = [];
                    selectedData.taskCodes = [];
                    selectedData.divisions = [];
                    let result = new Date(lastArchiveDate);
                    let archiveDate = new Date(result.setDate(result.getDate() - 1));
                    minimumDate = lastArchiveDate;
                    calanderEndDate = new Date();
                    if (isCheckedArchive) {
                        selectedData.selectedFromDate = null;
                        selectedData.selectedToDate = null;
                        selectedData.run = "";
                        selectedData.startDate = 0;
                        selectedData.endDate = 0;
                        selectedData.runReportAt = "";
                        selectedData.weekday = "";
                        selectedData.dateInMonth = 0;
                        selectedData.scheduleHour = "";
                        selectedData.scheduleMinute = "";
                        minimumDate = null;
                        calanderEndDate = archiveDate;
                    }
                    break;
                default:
                    break;
            }
            this.validateEmptyInputFields(e.target.name, value, true);
            this.setState({ selectedData: selectedData, selectedDivisionIds: this.state.selectedDivisionIds, userEmails, reportDelegateIds, isCheckedArchive, minimumDate, calanderEndDate });
        }
    }

    handleDateChange(date, fieldName) {
        const { selectedData } = this.state;

        if (((date !== null) && new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            this.validateEmptyInputFields(fieldName, date, true);
            if (fieldName === "selectedFromDate") {
                selectedData.selectedFromDate = new Date(date.toDateString());
            } else {
                selectedData.selectedToDate = new Date(date.toDateString());
            }

            if (selectedData.selectedFromDate && selectedData.selectedToDate && selectedData.selectedToDate < selectedData.selectedFromDate) {
                MessageBox(Constants.DATE_RAGE_VALIDATION, Constants.ERROR);
                return;
            }
            this.setState({ selectedData });
        }
    }

    onReportSearch = (e, { name, value }) => {
        const { searchArray } = this.state;
        const index = searchArray.findIndex(n => n.FieldName === name);
        if (index > -1 && value) {
            searchArray[index].value = value;
        } else if (index > -1) {
            searchArray.splice(index, 1);
        } else {
            searchArray.push({ FieldName: name, value: value });
        }

        this.setState({
            searchArray,
            pagination: {
                totalRecordCount: 0,
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            }
        }, () => {
            setTimeout(() => {
                this.getReportScheduleList();
            }, 1000);
        });
    }

    onCloseModel = (run = true) => {
        let { projectList } = this.state;
        this.setState({
            isOpenModel: false,
            selectedData: this.state.defaultStateSelectedData,
            selectedTypeDayOrDate: Constants.DAY,
            selectedTaskcodeIds: [],
            taskcodeList: [],
            taskcodeDBList: [],
            isCheckedArchive: false,
            selectedFromDate: new Date(),
            selectedToDate: new Date(),
            minimumDate: this.state.lastArchiveDate,
            calanderEndDate: new Date(),
            projectList: projectList.filter(a => a.key !== Constants.ALL_PROJECTS)
        }, () => {
            if (run) {
                this.getReportScheduleList();
            }
        });
    }

    onDeleteSchedule = (value) => {
        this.setState({ isDeleteConfirm: true, selectedData: value.data });
    }

    onCancelDelete = () => {
        this.setState({ isDeleteConfirm: false, selectedData: this.state.defaultStateSelectedData });
    }

    onConfirmDelete = () => {
        if (this.state.selectedData && this.state.selectedData.id > 0) {
            const url = `${ApiUrls.Routes.SCHDULER_C}${ApiUrls.Routes.GT_DELREPSCH_M}`;

            Api.Post(url, { id: this.state.selectedData.id }, this).then((responseData) => {
                if (responseData.success) {
                    this.setState({ isDeleteConfirm: false, selectedData: this.state.defaultStateSelectedData }, () => {
                        const apage = Math.ceil((this.state.pagination.totalRecordCount - 1) / Constants.DEFAULT_TAKE);
                        this.onPageChange(null, { activePage: this.state.pagination.activePage > apage ? apage : this.state.pagination.activePage });
                    });
                    // this.setState({ isDeleteConfirm: false, selectedData: {} }, () => {this.onPageChange(this.state.pagination.activePage);});
                }
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
            });
        }
    }

    onOpenModel = (value) => {
        let { projectDivList, userEmails, reportType, projectList, reportsAccessForProjectManager, selectedData, contributorsReports, readOnlyReports } = this.state;

        const roleName = this.props.user.roleName;
        const adminRoles = [Constants.ADMIN_ROLE_NAME, Constants.SYSTEM_ADMIN_ROLE_NAME];
        const isAdminRole = adminRoles.includes(roleName);

        const selectedReportType = value?.data?.reportType ?? "";
        const selectedDivisions = value?.data?.divisions ?? [];
        const selectedDivisionIds = selectedDivisions.map(a => a.divisionName);
        const selectedProjects = value?.data?.projects ?? [];
        const isSelectedAllProject = selectedProjects[0]?.isAllProject ?? false; // Here we are checking that user selected all project option, this is only valid for attestation reports

        const { attestationReports, projectManagerReports, taskInvolvedReports, tmVoucherMetricsReport, tmVoucherReports, unitNoteWithInstallRateReport } = this.groupedReportTypes();
        const isTMVoucherReport = tmVoucherReports.includes(selectedReportType);
        const isTMVoucherMetricsReport = tmVoucherMetricsReport.includes(selectedReportType);
        const isAttestationReport = attestationReports.includes(selectedReportType);
        const isTaskInvoledReport = taskInvolvedReports.includes(selectedReportType);
        const isProjectManagerReport = projectManagerReports.includes(selectedReportType);
        const isUnitNoteWithInstallRateReport = unitNoteWithInstallRateReport.includes(selectedReportType);

        const emptyReport = !value || !value?.data || Object.keys(value.data).length === 0;
        const allProjectOption = {
            value: Constants.ALL_PROJECTS,
            key: Constants.ALL_PROJECTS,
            text: "All Projects"
        };
        const url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_PRJT_TSK_CDS_M}?isTMCode=${isTMVoucherReport}`;
        const isAllProject = projectList[0]?.key === Constants.ALL_PROJECTS; // Only valid for attestation reports project list has AllProject option as first option

        switch (roleName) {
            case Constants.PROJECT_MANAGER:
                reportType = reportsAccessForProjectManager;
                break;
            case Constants.READ_ONLY:
                reportType = readOnlyReports;
                break;
            case Constants.CONTRIBUTE:
                reportType = contributorsReports;
                break;
            default:
                break;
        }

        if (emptyReport) {
            this.setState({
                isOpenModel: true,
                selectedData: selectedData,
                reportType,
                selectedProjectIds: [],
                selectedDivisionIds: [],
                sendReportToId: [],
                invalidDataFields: [],
                selectedTaskcodeIds: [],
                taskcodeList: [],
                taskcodeDBList: [],
                reportDelegateIds: [],
                disabledProjectsList: [],
                disabledTaskCodesList: [],
                disabledDivisionsList: [],
            });
            return;
        }

        // Setting all project option if not already selected for attestation reports for admin role
        if (isAdminRole && isAttestationReport && !isAllProject) {
            this.setState({ projectList: [allProjectOption, ...projectList] });
        }

        const runAt = value.data.runReportAt.split(" ");
        value.data.scheduleHour = runAt[0] === Constants.NOW ? runAt[0] : runAt[1] === "AM" ? parseInt(runAt[0].split(":")[0]) : parseInt(runAt[0].split(":")[0] + 12);
        if (runAt.length > 1) {
            value.data.scheduleMinute = parseInt(runAt[0].split(":")[1]);
        }

        const disabledProjects = selectedProjects.filter(p => !p.isAllProject && !projectList.map(v => v.value).includes(p.projectID));
        const disabledProjectsList = disabledProjects.map(d => ({
            id: d.projectID,
            value: d.projectID,
            key: d.projectID,
            text: `${d.projectNumber} - ${d.projectName}`,
        }));

        const disabledDivisions = selectedDivisions.filter(p => !projectDivList.map(v => v.value).includes(p.divisionName)) ?? [];
        const disabledDivisionsList = disabledDivisions.map(d => ({
            id: d.id,
            value: d.id,
            key: d.id,
            text: d.divisionName,
        }));

        const selectedProjectIds = selectedProjects.map(t => {
            if (t.isAllProject) {
                return Constants.ALL_PROJECTS;
            }
            return t.projectID;
        });

        // Fetch taskcodes for task involved reports like 6, 17, 18
        if (selectedProjectIds.length > 0 && isTaskInvoledReport) {
            Api.Post(url, selectedProjects, this).then((responseData) => {
                if (responseData && responseData.success) {
                    const allTaskCodeList = responseData.data;
                    const accessibleSelectedTaskCodes = allTaskCodeList.filter(d => !disabledProjectsList.some(v => d.projectId === v.id));
                    const taskCodeList = accessibleSelectedTaskCodes.map((d, i) => ({
                        value: d.id,
                        key: `${d.id}-${i}`,
                        text: `${d.taskNumber}-${d.taskName}`
                    }));

                    this.setState({
                        taskcodeList: taskCodeList,
                        taskcodeDBList: allTaskCodeList
                    }, () => {
                        // Filter saved task codes that is not present in the taskCodeList
                        const savedTaskCodes = value?.data?.taskCodes ?? [];
                        const taskCodeIds = taskCodeList.map(v => v.value);
                        const disabledTaskCodes = savedTaskCodes.filter(p => !taskCodeIds.includes(p.taskCodeID));
                        const disabledTaskCodesList = disabledTaskCodes.map((d, i) => ({
                            value: d.id,
                            key: `${d.id}-${i}`,
                            text: `${d.taskNumber}-${d.taskName}`
                        }));

                        const selectedTaskCodeIds = savedTaskCodes.map(a => a.taskCodeID);

                        this.setState({
                            selectedTaskcodeIds: selectedTaskCodeIds,
                            disabledTaskCodesList: disabledTaskCodesList,
                            selectedTypeDayOrDate: Constants.DAY
                        });
                    });
                } else {
                    this.setState({ taskcodeList: [] });
                }
            });
        }

        let reportDelegateIds = value?.data?.reportDelegate?.map(a => a.delegateUserId) ?? [];

        const reportDelegates = this.getReportDelegates(isAttestationReport, isSelectedAllProject, isProjectManagerReport, isUnitNoteWithInstallRateReport, isTMVoucherMetricsReport, userEmails, reportDelegateIds);
        reportDelegateIds = reportDelegates.reportDelegateIds;
        userEmails = reportDelegates.userEmails;

        const savedSendToReport = value?.data?.sendReportTo ?? [];
        const sendRptToId = savedSendToReport.map(a => `${a.contactType}-${(a.id > 0 ? a.id : (a.empID > 0 ? a.empID : a.userId))}`) ?? [];
        
        this.setState({
            isOpenModel: true,
            selectedData: value.data,
            selectedProjectIds: selectedProjectIds,
            selectedDivisionIds: selectedDivisionIds,
            sendReportToId: sendRptToId,
            invalidDataFields: [],
            reportDelegateIds,
            disabledProjectsList,
            disabledDivisionsList,
            userEmails,
            reportType
        });
    }

    handleStartDateChange = (e, { value }) => {
        if (this.state.selectedData) {
            const selectedData = Object.assign({}, this.state.selectedData);
            selectedData.startDate = parseInt(value);
            this.validateEmptyInputFields(e.target.name, value, true);
            this.setState({ selectedData: selectedData });
        }
    }

    onPageChange = (e, { activePage }) => {
        const { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;

        this.setState({
            pagination
        }, () => {
            this.getReportScheduleList();
        });
    }

    getReportDelegates(isAttestationReport, isSelectedAllProject, isProjectManagerReport, isUnitNoteWithInstallRateReport, isTmVoucherMetricsReport, userEmails, reportDelegateIds) {
        const { allUserEmails } = this.state;
        if (isAttestationReport) {
            // Report delegate emails, Attestation reports(19, 20) is not for readonly and project manager roles 
            // so emails of readonly and project manager should not be shown
            // and if the AllProject option is selected contribute role emails should not be shown 
            userEmails = allUserEmails.filter(a => ![Constants.READ_ONLY, Constants.PROJECT_MANAGER].includes(a.securityGroupName));
            if (isSelectedAllProject) {
                userEmails = userEmails.filter(a => a.securityGroupName !== Constants.CONTRIBUTE);
            }
        }
        else if (isTmVoucherMetricsReport) {
            // Report delegate emails, TmVoucher Metrics(22) is only for admin users
            userEmails = allUserEmails.filter(a => ![Constants.READ_ONLY, Constants.PROJECT_MANAGER, Constants.CONTRIBUTE].includes(a.securityGroupName));
        }
        else {
            // If project manager reports(13, 14, 17, 18) or Unit Notes Report with Date Range and Install Rates - Hours/Units(21)
            // is selected then show all the user emails
            // otherwise project manager emails should not be shown to the other reports
            userEmails = allUserEmails.filter(a => isProjectManagerReport || isUnitNoteWithInstallRateReport || a.securityGroupName !== Constants.PROJECT_MANAGER);
        }

        // Filter the reportDelegateIds array to keep only those values that exist in the emailsIds array.
        const emailIds = userEmails?.map(x => x.value) ?? [];
        emailIds.push(this.props.user.userId);
        return {
            reportDelegateIds: reportDelegateIds.filter(v => emailIds.includes(v)),
            userEmails
        };
    }

    render() {
        return (
            <Fragment>
                <ReportPageComponent
                    {...{
                        reportPage: this.state
                    }}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onOpenModel={this.onOpenModel.bind(this)}
                    onConfirmDelete={this.onConfirmDelete.bind(this)}
                    onCancelDelete={this.onCancelDelete.bind(this)}
                    onDeleteSchedule={this.onDeleteSchedule.bind(this)}
                    handleFormChange={this.handleFormChange.bind(this)}
                    isValidateFormData={this.isValidateFormData.bind(this)}
                    handleAddition={this.handleAddition.bind(this)}
                    onSubmit={this.saveReportScheduleDetails.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    onReportSearch={this.onReportSearch.bind(this)}
                    handleStartDateChange={this.handleStartDateChange.bind(this)}
                    handleDateChange={this.handleDateChange.bind(this)}
                    user={this.props.user}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportPage));

ReportPage.displayName = 'ReportPage';